const Theme = Object.freeze({
    Default: 'default-theme',
    BlackAndRed: 'black-red-theme',
    BlackAndRed2: 'black-red-theme-second',
    Orange: 'orange-theme',
});

const ThemeEnum = Object.freeze({
    0: 'Default',
    1: 'BlackAndRed',
    2: 'BlackAndRed2',
    3: 'Orange',
});

const WorkflowListStyle = Object.freeze({
    Default: 'Default',
    // Card: 'Card',
});

const AppListStyle = Object.freeze({
    Default: 'Default',
    Menu: 'Menu',
});

export { Theme, ThemeEnum, WorkflowListStyle, AppListStyle };
